import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const SuppressionList = () => import('./SuppressionList.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.ONE_OFF.HEADER',
        icon: 'sound-source',
      },
      children: [
        {
          path: '',
          redirect: 'one_off',
        },
        {
          path: 'one_off',
          name: 'one_off',
          meta: {
            permissions: ['administrator', 'supervisor'],
          },
          component: Index,
        },
        {
          path: 'suppressions',
          name: 'campaigns_suppressions',
          meta: {
            permissions: ['administrator'],
          },
          component: SuppressionList,
        },
      ],
    },
    // TODO_CLOUDCHAT: ongoing campaigns
    // {
    //   path: frontendURL('accounts/:accountId/campaigns'),
    //   component: SettingsContent,
    //   props: {
    //     headerTitle: 'CAMPAIGN.ONGOING.HEADER',
    //     icon: 'arrow-swap',
    //   },
    //   children: [
    //     {
    //       path: 'ongoing',
    //       name: 'ongoing_campaigns',
    //       meta: {
    //         permissions: ['administrator'],
    //       },
    //       component: Index,
    //     },
    //   ],
    // },
  ],
};
